import React from "react";
import { GetProdSetUpAtomData } from "../../store/productionSetupAtom";
import { useParams } from "react-router-dom";

const ProductionSetupScroll = ({ onSelect }) => {
  const { id } = useParams();
  const prodSetupData = GetProdSetUpAtomData();
  const items = prodSetupData?.production_item_info || [];

  return (
    /* 1. Ensure the outer container is locked to the parent's height */
    <div className="flex flex-col h-full bg-white border-r max-h-screen">
      
      {/* Fixed Header */}
      <div className="flex-none px-4 py-3 border-b bg-gray-50/50">
        <h3 className="text-xs font-bold text-gray-500 uppercase tracking-wider flex items-center justify-between">
          Finish Items
          <span className="bg-gray-200 text-gray-600 px-2 py-0.5 rounded-full text-[10px]">
            {items.length}
          </span>
        </h3>
      </div>

      {/* 2. Scrollable Content Area - added 'min-h-0' to force the scroll */}
      <div className="flex-1 min-h-0 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-200 hover:scrollbar-thumb-gray-300">
        {items.length === 0 ? (
          <div className="h-full flex flex-col items-center justify-center text-gray-400 p-8 text-center">
            <p className="text-sm font-medium">No items found</p>
          </div>
        ) : (
          <div className="divide-y divide-gray-100">
            {items.map((item, index) => {
              const isActive = Number(id) === Number(item?.Item_Id);

              return (
                <div
                  key={item.Item_Id || index}
                  onClick={() => onSelect(item)}
                  className={`
                    group px-4 py-3 cursor-pointer transition-all border-l-4
                    ${isActive 
                      ? "bg-indigo-50 border-l-indigo-600" 
                      : "bg-white border-l-transparent hover:bg-gray-50 hover:border-l-gray-300"}
                  `}
                >
                  <div className="flex flex-col gap-1.5">
                    <div className="flex justify-between items-start gap-2">
                      {/* Line-clamp-2 prevents text from being hidden entirely */}
                      <p className={`text-sm leading-tight line-clamp-2 ${isActive ? "text-indigo-900 font-semibold" : "text-gray-700 font-medium"}`}>
                        {item?.item_Name || "Unnamed Item"}
                      </p>
                      
                      <span className={`flex-shrink-0 text-[10px] px-1.5 py-0.5 rounded font-bold uppercase ${
                        isActive ? "bg-indigo-200 text-indigo-700" : "bg-gray-100 text-gray-500"
                      }`}>
                        {item?.No_of_Required_Item || 0} QTY
                      </span>
                    </div>

                    <p className="text-[11px] text-gray-400 font-mono">
                      {item?.Item_Sku || "NO-SKU"}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Fixed Footer */}
      {items.length > 0 && (
        <div className="flex-none px-4 py-2 bg-gray-50 border-t text-[10px] text-gray-400 text-right">
          Showing {items.length} items
        </div>
      )}
    </div>
  );
};

export default ProductionSetupScroll;